var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222,
    height: 83,
    viewBox: "0 0 222 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart-line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11463",
    "data-name": "Groupe 11463",
    transform: "translate(223.774 74.57) rotate(-177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11462",
    "data-name": "Groupe 11462",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1283",
    "data-name": "Trac\\xE9 1283",
    d: "M0,9.985c13.431-4.123,24.684-1.053,32.267,4.206,1.709,1.185,3.917,3.217,2.54,4.775-1.048,1.186-4.1,1.2-4.56-.309-1.139-3.72,5.885-4.914,9.722-5.555A62.9,62.9,0,0,1,88.754,25.7C105.294,38.816,97.208,49.584,96,50.878,85.42,62.226,72.687,42.941,79.95,42.322c6.727-.573-3.769,25.793-16.919,17.744-10.059-6.157-5.1-32.467,19.3-45.771C106.283,1.229,149.641-5.8,168.034,6.075c10.026,6.472,7.716,15.418,3.5,11.691-1.135-1-2.507-6.134,6.124-6.69,11.071-.714,21.569,4.268,33.591-1.091",
    transform: "translate(0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLine);
export default __webpack_public_path__ + "static/media/heart-line.3661210588487bac8b4546bec3c850b1.svg";
export { ForwardRef as ReactComponent };